import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import LyricsToggleIcon from './icons/LyricsToggleIcon';

interface LyricsToggleProps {
    showLyrics: boolean;
    onToggleLyrics: () => void;
}

const LyricsToggle: React.FC<LyricsToggleProps> = ({
    showLyrics,
    onToggleLyrics,
}) => {
    const { theme } = useTheme();

    return (
        <button
            onClick={onToggleLyrics}
            style={{
                width: '32px',
                height: `${theme.spacing.xl - 4}px`, // 20px
                borderRadius: `${theme.radii.full}px`,
                padding: '2px',
                position: 'relative',
                backgroundColor: showLyrics ? theme.colors.lyrics : theme.colors.textSecondary,
                border: 'none',
                cursor: 'pointer',
                transition: `all ${theme.motion.duration.fast}ms ${theme.motion.easing.standard}`,
            }}
            aria-label={showLyrics ? 'Hide lyrics' : 'Show lyrics'}
            title={showLyrics ? 'Hide lyrics' : 'Show lyrics'}
        >
            <div
                style={{
                    width: `${theme.spacing.lg}px`, // 16px
                    height: `${theme.spacing.lg}px`, // 16px
                    borderRadius: `${theme.radii.lg}px`,
                    backgroundColor: theme.colors.background,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'absolute',
                    left: showLyrics ? 'calc(100% - 18px)' : '2px',
                    top: '2px',
                    transition: `all ${theme.motion.duration.fast}ms ${theme.motion.easing.standard}`,
                }}
            >
                <LyricsToggleIcon
                    size={8}
                    color={showLyrics ? theme.colors.lyrics : theme.colors.textTertiary}
                />
            </div>
        </button>
    );
};

export default LyricsToggle;
